// extracted by mini-css-extract-plugin
module.exports = {"WomanList":"styles_WomanList__3TCZx","WomanList-items":"styles_WomanList-items__1TGU3","WomanList-feedback":"styles_WomanList-feedback__2RoZf"};